import { useGLTF, useTexture } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import { useRef, forwardRef, useImperativeHandle } from 'react';
import * as THREE from 'three';

const TruckWheels = forwardRef(({ position = [0, 20, 0], isRotate = false }, ref) => {
    const wheelsNodes = useGLTF('./models/truck/truckWheels.glb');
    const wheelsTexture = useTexture('./textures/truck/truckWheels.jpg');
    wheelsTexture.flipY = false;

    const wheelsRef = useRef();

    useImperativeHandle(ref, () => ({
        get rotation() {
            return wheelsRef.current.rotation;
        },
        set rotation(value) {
            wheelsRef.current.rotation = value;
        },
        ...wheelsRef.current
    }), [wheelsRef]);

    useFrame(() => {
        if (isRotate && wheelsRef.current) {
            wheelsRef.current.rotation.x += 0.06; 
        }
    });

    return (
        <mesh
            ref={wheelsRef}
            geometry={wheelsNodes.nodes.wheels.geometry}
            position={position}
            onClick={(event) => event.stopPropagation()}
            onPointerEnter={(event) => event.stopPropagation()}
            renderOrder={2}
        >
            <meshBasicMaterial 
                map={wheelsTexture} 
                transparent={true} 
                opacity={0.2} 
                // depthWrite={false} 
                blending={THREE.NormalBlending} 
            />
        </mesh>
    );
});

export default TruckWheels;
